import { Base } from "../Base";
export class Class extends Base {
    base;
    class = "readonly";
    _name;
    get name() {
        return (this._name ??= `Readonly<${this.base.name}>`);
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.definition });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return value === undefined || this.base.is(value);
    }
    prune(value) {
        return this.base.prune(value);
    }
    static create(base, name) {
        return new Class(base, name);
    }
}
//# sourceMappingURL=Class.js.map